import React from 'react';
import './nav.scss';
//import ScrollSpy from 'react-scrollspy-navigation';

export function Nav() {
  const handleClick = (e: { target: any; }) => {
    document.querySelectorAll('.nav-link').forEach(e => e.classList.remove('active'));
    e.target.classList.add('active');
  }
  return (
    <nav id="navbar" className='navbar sticky-top navbar-expand-lg'>
      <div className="container-fluid">
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
        <div className="collapse navbar-collapse" id="navbarToggler">
          <ul className='navbar-nav me-auto mb-2 mb-lg-0' onClick={handleClick}>
            <li className="nav-item"><a className='nav-link icon_home' href="#home">&nbsp;</a></li>
            <li className="nav-item"><a className='nav-link icon_price' href="#price">услуги и цены</a></li>
            <li className="nav-item"><a className='nav-link icon_vacancy' href="#vacancy">вакансии</a></li>
            <li className="nav-item"><a className='nav-link icon_contact' href="#contact">как нас найти</a></li>
            <li className="nav-item hide is-current"><a className='nav-link icon_social' href="#social">мы в оцсетях</a></li>
          </ul>
        <a href="tel:88129213626" className='tel'><small>(812)</small> 921 36 26</a>
        </div>
      </div>
    </nav>
  );
}
